import { render, staticRenderFns } from "./MealForm.vue?vue&type=template&id=2efe1404&scoped=true"
import script from "./MealForm.vue?vue&type=script&lang=js"
export * from "./MealForm.vue?vue&type=script&lang=js"
import style0 from "./MealForm.vue?vue&type=style&index=0&id=2efe1404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe1404",
  null
  
)

export default component.exports